<div class="notification-card" (click)="handleClick()">
  <div><b>{{title}}</b></div>
  <div>{{subtitle}}</div>
</div>
